let currentCoder = "正式"; //客户端开发者，调试时更改 以区分服务端API，与下方api.baseUrl一一对应；

let baseUrl = "http://192.168.160.111:8763";
let imgBaseUrl = "http://192.168.160.164:8090/upload";
let localurl = location.href;
export default {
    GetApiBaseUrl: function() {
        //----------- 自定义API地址---begin-----根据currentCoder与他人区分- 
        //http://192.168.160.19:8080
        //http://192.168.160.111:8765
        baseUrl = currentCoder == "本地" ? "http://192.168.160.111:8080" : baseUrl;
        baseUrl = currentCoder == "正式" ? "https://notifyServer.ctgpayroll.com" : baseUrl;

        //通知必达
        baseUrl = localurl.indexOf("notify.ctgpayroll.com") >= 0 ? "https://notifyServer.ctgpayroll.com" : baseUrl;

        //-----------------------------end--------------------------------------------------------------------
        return baseUrl;
    },
    GetImgBaseUrl: function() {
        //----------- 自定义IMG地址---begin-----根据currentCoder与他人区分-------------------------------
        //
        imgBaseUrl = currentCoder == "本地" ? "http://192.168.160.164:8090/upload/" : imgBaseUrl;
        imgBaseUrl = currentCoder == "正式" ? "https://notifyfile.ctgpayroll.com/upload" : imgBaseUrl;
        //
        imgBaseUrl = localurl.indexOf("notify.ctgpayroll.com") >= 0 ? "https://notifyfile.ctgpayroll.com/upload" : imgBaseUrl;

        //-----------------------------end--------------------------------------------------------------------
        return imgBaseUrl;
    }
}

//-----------------------------end------------------------------------------